import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from "antd";
import { useRef } from "react";
import { FormTcfVendorFieldDataDeclaration } from "./fields/dataDeclaration.js";
import { FormTcfVendorFieldDeviceStorage } from "./fields/deviceStorage.js";
import { FormTcfVendorFieldFeatures } from "./fields/features.js";
import { FormTcfVendorFieldGeneralCompose } from "./fields/general/compose.js";
import { FormTcfVendorFieldPurposes } from "./fields/purposes.js";
import { FormTcfVendorFieldTemplateCheck } from "./fields/templateCheck.js";
import { useI18n } from "../../../contexts/i18n.js";
import { FormLayoutTcfVendor } from "../layout.js";
const FormTcfVendor = ()=>{
    const { __ } = useI18n();
    const ref = useRef();
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(FormTcfVendorFieldGeneralCompose, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldDeviceStorage, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldPurposes, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldFeatures, {}),
            /*#__PURE__*/ _jsx(FormTcfVendorFieldDataDeclaration, {}),
            /*#__PURE__*/ _jsxs(Form.Item, {
                className: "rcb-antd-form-sticky-submit",
                labelCol: {
                    span: 0
                },
                wrapperCol: {
                    span: 24
                },
                children: [
                    /*#__PURE__*/ _jsx(FormTcfVendorFieldTemplateCheck, {}),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        wrapperCol: {
                            offset: FormLayoutTcfVendor.labelCol.span
                        },
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ _jsx("input", {
                                type: "submit",
                                className: "button button-primary",
                                value: __("Save")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
export { FormTcfVendor };
